/**
 * Old Amazon dashboard overview card metrics — mapped to wrapper (adset) keys.
 * sale_value (legacy) → revenue (wrapper).
 */

export const AMAZON_OVERVIEW_MEASURES = [
  "spends",
  "impressions",
  "clicks",
  "orders",
  "revenue",
  "roas",
  "ctr",
  "cpc",
  "cpm",
  "cvr",
  "aov",
  "acos",
];

export const AMAZON_OVERVIEW_DEFAULT_VISIBLE = [
  "spends",
  "impressions",
  "clicks",
  "orders",
  "revenue",
  "ctr",
];

export const AMAZON_OVERVIEW_METRICS = [
  {
    key: "spends",
    shortTitle: "Spends",
    title: "Spends",
    isCurrencyFormat: true,
    maximumFractionDigits: 0,
  },
  {
    key: "impressions",
    shortTitle: "Impressions",
    title: "Impressions",
    maximumFractionDigits: 0,
  },
  {
    key: "clicks",
    shortTitle: "Clicks",
    title: "Clicks",
    maximumFractionDigits: 0,
  },
  {
    key: "orders",
    shortTitle: "Orders",
    title: "Orders",
    maximumFractionDigits: 0,
  },
  {
    key: "revenue",
    shortTitle: "Sales Value",
    title: "Sales Value",
    isCurrencyFormat: true,
    maximumFractionDigits: 0,
  },
  {
    key: "ctr",
    shortTitle: "CTR",
    title: "CTR",
    format: "percent",
    maximumFractionDigits: 2,
  },
  {
    key: "cvr",
    shortTitle: "CVR",
    title: "CVR",
    format: "percent",
    maximumFractionDigits: 2,
  },
  {
    key: "cpm",
    shortTitle: "CPM",
    title: "CPM",
    isCurrencyFormat: true,
    maximumFractionDigits: 2,
  },
  {
    key: "aov",
    shortTitle: "AOV",
    title: "AOV",
    isCurrencyFormat: true,
    maximumFractionDigits: 2,
  },
  {
    key: "cpc",
    shortTitle: "CPC",
    title: "CPC",
    isCurrencyFormat: true,
    maximumFractionDigits: 2,
  },
  {
    key: "roas",
    shortTitle: "ROAS",
    title: "ROAS",
    maximumFractionDigits: 2,
  },
  {
    key: "acos",
    shortTitle: "ACOS",
    title: "ACOS",
    format: "percent",
    maximumFractionDigits: 2,
  },
];

export const AMAZON_OVERVIEW_DIMENSIONS = ["campaign_name", "campaign_id"];
